import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0px 2vw;
`;

export const BannerContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: space-between;
  width: 100%;
  margin-top: 30px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
`;

export const HeaderIcon = styled.img`
  margin-right: 10px;
  width: 24px;
  height: 24px;
`;

export const StyledHeading = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  color: #123051;
`;

export const Boards = styled.div`
  display: flex;
  gap: 16px;
`;

export const Board = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #e1e1e1;
  flex: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 8px;
  border-radius: 4px;
  flex-direction: column;
  padding: 16px;
  flex-grow: 1;
  background-color: ${(props) => props.backgroundColor};
  justify-content: ${(props) => (props.noData ? "center" : "normal")};
  align-items: ${(props) => (props.noData ? "center" : "normal")};
`;

export const Title = styled.div`
  font-family: "DM Sans", sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
`;

export const SubTitle = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
`;

export const HeadlineContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const StyledIcon = styled.img`
  width: 20px;
  height: 20px;
`;

export const HeadlineImage = styled.img`
  width: 100%;
  max-height: 12vh;
  border-radius: 4px;
  border: 1px solid #f9fafb;
  object-fit: cover;
`;

export const Headline = styled.span`
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  color: #123051;
  font-family: "DM Sans", sans-serif;
  height: 100%;
  white-space: no-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Separator = styled.div`
  border: 1px solid #e1e1e1;
  width: 100%;
`;

export const TableHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TableTitle = styled.div`
  font-size: 20px;
  line-height: 20px;
  font-weight: 700;
  font-family: "DM Sans", sans-serif;
  color: #123051;
`;

export const NoDataTitle = styled.span`
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #123051;
  text-align: center;
`;
